export default __webpack_public_path__ + "static/media/fad-logo-abletonlink.4e895602.svg";